import React from 'react';
import styled from 'styled-components';

type DividerProps = {
  variant?: 'dots' | 'wave' | 'gradient' | 'chevron' | 'diamond';
  className?: string;
}

const DividerContainer = styled.div`
  width: 100%;
  padding: 40px 0;
  display: flex;
  justify-content: center;
`;

const DiamondDividerContent = styled.div`
  position: relative;
  width: 100%;
  max-width: 1200px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HorizontalLine = styled.div`
  position: absolute;
  height: 6px;
  background-color: #004744;
  width: 90%;
`;

const DiamondWrapper = styled.div`
  padding: 20px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Diamond = styled.div`
  width: 30px;
  height: 30px;
  background-color: #004744;
  transform: rotate(45deg);
  box-shadow: 0 4px 8px rgba(255, 255, 255, 0.3);
`;

const Divider = ({ variant = 'dots', className = '' }: DividerProps) => {
  switch (variant) {
    case 'diamond':
      return (
        <DividerContainer className={className}>
          <DiamondDividerContent>
            <HorizontalLine />
            <DiamondWrapper>
              <Diamond />
            </DiamondWrapper>
          </DiamondDividerContent>
        </DividerContainer>
      );
    case 'wave':
    case 'gradient':
    case 'chevron':
    case 'dots':
    default:
      // Default to diamond for now
      return (
        <DividerContainer className={className}>
          <DiamondDividerContent>
            <HorizontalLine />
            <DiamondWrapper>
              <Diamond />
            </DiamondWrapper>
          </DiamondDividerContent>
        </DividerContainer>
      );
  }
};

export default Divider; 